export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/dealer/updateDealerData',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allDealers'],
       
    })
